// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, setAnalyticsCollectionEnabled } from "firebase/analytics";
import { ProviderId, getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getFirestore } from "firebase/firestore"

import { getStorage, ref, uploadBytes } from "firebase/storage"

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

const analytics = getAnalytics(app);

// GDPR Compliance Logic Default State
const consent = typeof window !== 'undefined' ? localStorage.getItem('tapesignal_cookie_consent') : null;
if (consent !== 'accepted') {
    setAnalyticsCollectionEnabled(analytics, false);
} else {
    setAnalyticsCollectionEnabled(analytics, true);
}

export { analytics };

export { firebaseConfig as firebase }

const db = getFirestore(app);

const storage = getStorage(app);

export { db };

export { storage };